import React from "react";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import { setRegionIcon } from "../../../components/RegionCard/region-card";
import "./styles.scss";

interface TeamCardProps {
  name: string;
  region: string;
  country: string;
  track: string;
  setRegionColor: (region: string) => string;
}

export const camelize = (str: string): string =>
  str.replace(/\b\w/g, (l) => l.toUpperCase());

export const TeamCard = (props: TeamCardProps): JSX.Element => {
  const { name, region, country, setRegionColor, track } = props;
  return (
    <li className="tc">
      <div className="tc-wrapper">
        <div className="tc__header">
          <div
            className="tc__header-bookmark"
            style={{ backgroundColor: setRegionColor(region) }}
          />
        </div>
        <div className="tc__body">
          <h6>{name}</h6>
          <p className="track">{track === "High School" ? track : undefined}</p>
        </div>
        <div className="tc__footer">
          <div className="tc__footer-region">
            <img src={setRegionIcon(region)} alt={`region-${name}`} />
            <h6>{region}</h6>
          </div>
          <div className="tc__footer-country">
            <LocationOnIcon />
            <h6>{camelize(country.toLowerCase())}</h6>
          </div>
        </div>
      </div>
    </li>
  );
};
